module.exports = __webpack_public_path__ + "img/JH.6134b005.png";